import { useParams } from 'react-router-dom';

import { DocMentionsInput } from '@/new/components/doc-mentions-input';

interface KimInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export function KimInput({ value, onChange, onSubmit, placeholder, className, disabled }: KimInputProps) {
  const { matterId, subsetId } = useParams();

  if (!matterId || !subsetId) return null;

  return (
    <DocMentionsInput
      value={value}
      onChange={onChange}
      onSubmit={onSubmit}
      matterId={matterId}
      subsetId={subsetId}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
    />
  );
}
